import {
  OrderBaseFieldsFragment,
  UploadedFileCategory,
  UploadedFileStatus,
} from 'src/types';

/**
 * Returns the most recent slide image for an order.
 * Prioritizes in-progress uploads, then the most recent completed upload.
 */
export const findMostRecentSlideImage = (order: OrderBaseFieldsFragment) => {
  const slideImages =
    order.uploadedFiles?.edges?.filter(
      (edge) => edge!.node?.category === UploadedFileCategory.SlideImage,
    ) || [];

  if (slideImages.length === 0) return null;

  // Prioritize in-progress uploads
  const inProgressUpload = slideImages.find(
    (edge) => edge!.node?.status === UploadedFileStatus.InProgress,
  );
  if (inProgressUpload?.node) return inProgressUpload.node;

  // Then find most recent completed upload
  const completedUploads = slideImages.filter(
    (edge) => edge!.node?.status === UploadedFileStatus.Complete,
  );

  if (completedUploads.length === 0) return null;

  const mostRecent = completedUploads.sort((a, b) => {
    const dateA = new Date(a?.node?.createdAt || 0).getTime();
    const dateB = new Date(b?.node?.createdAt || 0).getTime();
    return dateB - dateA;
  })[0];

  return mostRecent!.node;
};
